import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const atLeastTwoWordsValidator = (
  control: AbstractControl,
): { invalid: string } | null => {
  const value = String(control.value ?? '').trim();
  if (!value) {
    return { invalid: 'Value should has at least 2 words' };
  }

  const valueArray = value.split(' ');
  return valueArray.length > 1
    ? null
    : { invalid: 'Value should has at least 2 words' };
};

export const confirmPasswordValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value as {
    password?: string;
    confirmPassword?: string;
  } | null;

  return value?.password === value?.confirmPassword
    ? null
    : { PasswordNoMatch: true };
};

export const passwordStrength: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = String(control?.value ?? '');
  const lower = value?.search(/(?=.*[a-z])/) < 0;
  const upper = value?.search(/(?=.*[A-Z])/) < 0;
  const specialSymbol = value?.search(/(?=.*[!@#$%^&*])/) < 0;
  const digit = value?.search(/[0-9]/) < 0;
  const length = value?.length < 8;

  type ErrorKeys = 'lower' | 'upper' | 'specialSymbol' | 'digit' | 'length';

  const errors: Partial<Record<ErrorKeys, boolean>> = {
    lower,
    upper,
    specialSymbol,
    digit,
    length,
  };

  if (!lower) {
    delete errors.lower;
  }

  if (!upper) {
    delete errors.upper;
  }

  if (!specialSymbol) {
    delete errors.specialSymbol;
  }
  if (!digit) {
    delete errors.digit;
  }
  if (!length) {
    delete errors.length;
  }

  return Object.values(errors)?.length ? errors : null;
};

